// Core Components
import Toolbar from "../components/core/Toolbar.vue";
import Navigation from "../components/core/NavigationDrawer.vue";
import Breadcrumbs from "../components/core/Breadcrumbs.vue";
import PageFooter from "../components/core/PageFooter.vue";

//Modales
import ModalForgetPass from "../components/modals/ModalForgetPass.vue";
import ModalAuthChangePass from "../components/modals/ModalAuthChangePass.vue";
import ModalAuthPIN from "../components/modals/ModalAuthPIN.vue";
import ModalPersonalData from "../components/modals/ModalPersonalData.vue";
import ModalChangePass from "../components/modals/ModalChangePass.vue";
import ModalUsers from "../components/modals/ModalUsers.vue";
import OptionalModals from "../components/modals/OptionalModals.vue";
import OptionalModalsOld from "../components/modals/old/OptionalModalsOld.vue";

//UI Components
import DataSensorChart from "../components/dashboard/DataSensorChart.vue";
import DashboardCompras from "../components/dashboard/DashboardCompras.vue";

//Tabla
import MyTable from "../components/table/MyTable.vue";
import DetailRow from "../components/table/DetailRow.vue";
import MyTableOld from "../components/table/old/MyTableOld.vue";
import DetailRowOld from "../components/table/old/DetailRowOld.vue";

//Loader
import LoaderAnim from "../components/ui/LoaderAnim.vue";
import LoaderPaint from "../components/ui/LoaderPaint.vue";
import BoatSailing from "../components/ui/BoatSailing.vue";

//DatePicker with Time
import DatePicker from "vue2-datepicker";
import VueEvents from "vue-events";
import "vue2-datepicker/index.css";

function setupComponents(Vue) {
  Vue.component("toolbar", Toolbar);
  Vue.component("navigation", Navigation);
  Vue.component("breadcrumbs", Breadcrumbs);
  Vue.component("page-footer", PageFooter);

  Vue.component("modal-forget-pass", ModalForgetPass);
  Vue.component("modal-personal-data", ModalPersonalData);
  Vue.component("modal-change-pass", ModalChangePass);
  Vue.component("modal-users", ModalUsers);
  Vue.component("modal-auth-pin", ModalAuthPIN);
  Vue.component("modal-auth-change-pass", ModalAuthChangePass);
  Vue.component("optional-modals", OptionalModals);
  Vue.component("optional-modals-old", OptionalModalsOld);

  Vue.component("data-sensor-chart", DataSensorChart);
  Vue.component("dashboard-compras", DashboardCompras);

  Vue.component("my-table", MyTable);
  Vue.component("my-detail-row", DetailRow);
  Vue.component("my-table-old", MyTableOld);
  Vue.component("my-detail-row-old", DetailRowOld);

  Vue.component("loader-anim", LoaderAnim);
  Vue.component("loader-paint", LoaderPaint);
  Vue.component("boat-sailing", BoatSailing);

  Vue.use(VueEvents);

  Vue.use(DatePicker);
}

export { setupComponents };



// WEBPACK FOOTER //
// ./src/config/setup-components.js